var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "branding-tab" }, [
    _c(
      "div",
      { staticClass: "branding-card" },
      [
        _c("h2", { staticClass: "card-title" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("pages.settings.branding.logo.title")) + " "
          ),
        ]),
        _c("p", { staticClass: "card-description" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("pages.settings.branding.logo.description")) +
              " "
          ),
        ]),
        _c("LogoUpload"),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "branding-card" },
      [
        _c("h2", { staticClass: "card-title" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t("pages.settings.branding.primaryColor.title")) +
              " "
          ),
        ]),
        _c("p", { staticClass: "card-description" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t("pages.settings.branding.primaryColor.description")
              ) +
              " "
          ),
        ]),
        _c("PrimaryColorPicker"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }